import { schema } from 'normalizr';

const articleSchema = new schema.Entity('articles', {});

export default articleSchema;
